import * as Yup from "yup";
import MESSAGE from "~/utils/messages";

export const schema = Yup.object().shape({
  Email: Yup.string()
    .matches(
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g,
      MESSAGE.invalidMail
    )
    .required(MESSAGE.requiredField),
  Senha: Yup.string()
    .min(8, MESSAGE.passwordMatch)
    .max(32, MESSAGE.passwordMatch)
    .required(MESSAGE.requiredField)
    .test({
      name: "newPasswordNumber",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[0-9]/.test(value), // Simplificado
    })
    .test({
      name: "newPasswordString",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[a-zA-Z]/.test(value), // Simplificado
    })
    .test({
      name: "newPasswordSpecialCharacter",
      message: MESSAGE.passwordMatch,
      test: (value) => value && /[^a-zA-Z0-9]/.test(value), // Simplificado
    }),
});
